<ng-container [formGroup]="clientForm">
  <app-section
    title="Destinatário"
    description="Preencha os dados pessoais ou juridicos do destinatário da operação."
  >
    <app-fields>
      <app-input
        label="CPF/CNPJ"
        mask="000.000.000-00||00.000.000/0000-00"
        formControlName="cpfCnpj"
        invalidMessage="CPF/CNPJ inválido"
        autocomplete="organization"
      ></app-input>
      <app-input
        [label]="juridicPerson() ? 'Razão Social' : 'Nome'"
        formControlName="razaoSocial"
        autocomplete="organization name"
        [maxlength]="razaoSocialMaxLength"
      ></app-input>
      <app-input label="E-mail" formControlName="email"></app-input>
      <ng-container *ngIf="juridicPerson()">
        <app-input
          formControlName="inscricaoEstadual"
          label="Inscrição estadual"
          [invalidMessage]="inscricaoEstadualInvalidMessage()"
        ></app-input>
        <app-select
          [options]="yesOrNot"
          formControlName="orgaoPublico"
          label="Orgão público"
        ></app-select>
        <app-select
          label="Indicador da inscrição estadual"
          [options]="indIeDestOptions"
          formControlName="indicadorInscricaoEstadual"
        >
        </app-select>
      </ng-container>
    </app-fields>
  </app-section>
  <app-section
    title="Endereço"
    description="Informe o endereço principal do destinatário."
    formGroupName="endereco"
  >
    <app-fields>
      <app-input
        autocomplete="postal-code"
        label="CEP"
        mask="00.000-000"
        formControlName="cep"
        [dropSpecialCharacters]="true"
      ></app-input>
      <app-input
        [disabled]="true"
        label="Código da cidade (IBGE)"
        formControlName="codigoCidade"
        [dropSpecialCharacters]="true"
        mask="0000000"
      ></app-input>
      <app-button
        *ngIf="showAddressLookupButton && hasMainAddressDataMissing()"
        text="Buscar dados do endereço na API"
        icon="pi-search"
        type="button"
        onKeyDown=""
        [loading]="isSearchingAddress()"
        [disabled]="!canSearchAddressInApi()"
        (click)="searchMissingAddressData()"
      ></app-button>
      <app-select
        [options]="states()"
        formControlName="estado"
        label="Estado"
      ></app-select>
      <app-select
        *ngIf="cities().length"
        [options]="cities()"
        label="Cidade"
        formControlName="descricaoCidade"
      ></app-select>
      <app-input label="Bairro" formControlName="bairro"></app-input>
      <app-input
        label="Logradouro"
        formControlName="logradouro"
        [maxlength]="60"
      ></app-input>
      <app-select
        [options]="tipoLogradouroOptions"
        label="Tipo de logradouro"
        formControlName="tipoLogradouro"
      ></app-select>
      <app-input label="Número" formControlName="numero"></app-input>
      <app-input label="Complemento" formControlName="complemento"></app-input>
    </app-fields>
  </app-section>
</ng-container>
